import React from 'react';
import '../Css/About.css';
import hr_line from '../Images/hr_line2.png';
import authentic from '../Images/authentic.png';
import affordable from '../Images/affordable.png';
import customer from '../Images/Customer.png';
import { LazyShow2 } from './LazyShow';

const About = () => {
  return (
    <div className='about_sec' id='about'>
        <div className='section_heading'>
            <h2>ABOUT US</h2>
            <img src={hr_line}/>
        </div>
        <div className='content_wrapper'>
            <div className='section_subheading'>
                <h5>WHY KOYARK</h5>
            </div>
            <LazyShow2>
                <div className='card_wrapper'>
                    <div className='card card1'>
                        <img className='card_img' src={authentic}/>
                        <h4>Authentic Products</h4>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='card card2'>
                        <img src={customer}/>
                        <h4>Customer Satisfaction</h4>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                    <div className='card card3'>
                        <img src={affordable}/>
                        <h4>Affordable Prices</h4>
                        <p>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.</p>
                    </div>
                </div>
            </LazyShow2>
        </div>
    </div>
  )
}

export default About;